// src/pages/Terms.tsx
import { Link } from "react-router-dom";

export default function Terms() {
  const updatedAt = "January 2026"; // ajusta cuando quieras

  return (
    <div className="min-h-screen bg-[#0b0b0f] text-white flex flex-col">
      {/* ─────────── HEADER ─────────── */}
      <header className="border-b border-white/10 bg-[#0b0b0f]/70 backdrop-blur-md sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="text-xl font-bold">
            Ovylon <span className="text-sm text-gray-400 font-medium ml-2">AI Studio</span>
          </Link>

          <div className="flex gap-3">
            <Link
              to="/register"
              className="px-4 py-2 bg-white text-black rounded-lg font-semibold hover:bg-gray-200 transition"
            >
              Crear cuenta
            </Link>
            <Link
              to="/login"
              className="px-4 py-2 border border-white/15 rounded-lg hover:bg-white/10 transition"
            >
              Iniciar sesión
            </Link>
          </div>
        </div>
      </header>

      {/* ─────────── CONTENT ─────────── */}
      <main className="flex-1 max-w-6xl mx-auto px-6 py-16">
        <div className="text-xs uppercase tracking-[0.25em] text-gray-400">Términos</div>
        <h1 className="text-3xl md:text-4xl font-bold mt-3">Términos de uso</h1>
        <p className="text-sm text-gray-400 mt-3">
          Última actualización: <span className="text-gray-200 font-medium">{updatedAt}</span>
        </p>

        <div className="mt-10 space-y-6 text-gray-300 leading-relaxed">
          {/* 1 */}
          <section className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <h2 className="text-lg font-semibold text-gray-100">1) Aceptación de los términos</h2>
            <p className="mt-3 text-sm text-gray-300">
              Al acceder o usar Ovylon™, aceptas estos Términos y nuestra{" "}
              <Link to="/privacy" className="text-indigo-300 hover:text-indigo-200 transition">
                Política de Privacidad
              </Link>
              . Si no estás de acuerdo, no uses la plataforma.
            </p>
          </section>

          {/* 2 */}
          <section className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <h2 className="text-lg font-semibold text-gray-100">2) Quién puede usar Ovylon</h2>
            <ul className="mt-3 text-sm text-gray-300 space-y-2">
              <li>• Debes poder celebrar un contrato legal en tu jurisdicción.</li>
              <li>• Si usas Ovylon en nombre de una empresa/equipo, declaras tener autorización para hacerlo.</li>
              <li>• Eres responsable de la actividad que ocurra desde tu cuenta.</li>
            </ul>
          </section>

          {/* 3 */}
          <section className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <h2 className="text-lg font-semibold text-gray-100">3) Cuenta, seguridad y acceso</h2>
            <ul className="mt-3 text-sm text-gray-300 space-y-2">
              <li>• Mantén tu acceso seguro (correo, contraseña, enlaces de acceso, etc.).</li>
              <li>• No compartas tu cuenta de forma que viole tu plan o límites.</li>
              <li>• Podemos suspender o limitar acceso si detectamos fraude, abuso o actividad riesgosa.</li>
            </ul>
          </section>

          {/* 4 */}
          <section className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <h2 className="text-lg font-semibold text-gray-100">4) Planes, créditos, límites y cambios</h2>
            <p className="mt-3 text-sm text-gray-300">
              Ovylon ofrece planes y/o créditos para habilitar capacidades (por ejemplo: resoluciones, piezas, persistencia
              de Brand Kit, límites por mes). La disponibilidad exacta se muestra dentro del producto según tu plan activo.
            </p>
            <ul className="mt-3 text-sm text-gray-300 space-y-2">
              <li>• Podemos actualizar planes, precios, límites o características para mejorar el servicio o ajustarnos al mercado.</li>
              <li>• Si realizas compras, aceptas pagar los importes aplicables y los impuestos que correspondan.</li>
              <li>• Los créditos (si aplican) pueden tener reglas de expiración/uso visibles en la app.</li>
            </ul>
          </section>

          {/* 5 */}
          <section className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <h2 className="text-lg font-semibold text-gray-100">5) Uso permitido y prohibiciones</h2>
            <p className="mt-3 text-sm text-gray-300">
              Queremos que Ovylon sea útil y seguro. Por eso, no permitimos usar la plataforma para actividades ilegales
              o dañinas. En particular, aceptas no:
            </p>
            <ul className="mt-3 text-sm text-gray-300 space-y-2">
              <li>• Infringir derechos de autor, marcas, privacidad o cualquier derecho de terceros.</li>
              <li>• Generar o distribuir contenido ilegal o destinado a engañar/estafar de forma maliciosa.</li>
              <li>• Intentar vulnerar la seguridad, extraer datos, hacer scraping masivo o abusar de la infraestructura.</li>
              <li>• Usar Ovylon para crear contenido que viole leyes aplicables o políticas internas del producto.</li>
            </ul>
            <p className="mt-3 text-xs text-gray-400">
              Si detectamos abuso, podemos suspender o terminar el acceso para proteger a usuarios y al servicio.
            </p>
          </section>

          {/* 6 */}
          <section className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <h2 className="text-lg font-semibold text-gray-100">6) Contenido, prompts y resultados generados</h2>
            <ul className="mt-3 text-sm text-gray-300 space-y-2">
              <li>• Tú controlas lo que ingresas (por ejemplo: prompts, briefs, referencias) y eres responsable de ello.</li>
              <li>
                • Los resultados generados pueden variar y no garantizamos que siempre sean perfectos, exactos o libres de
                similitudes no intencionales.
              </li>
              <li>
                • Es tu responsabilidad revisar lo generado antes de publicarlo, usarlo en anuncios, venderlo o entregarlo a
                clientes.
              </li>
            </ul>
          </section>

          {/* 7 */}
          <section className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <h2 className="text-lg font-semibold text-gray-100">7) Propiedad intelectual y marca</h2>
            <p className="mt-3 text-sm text-gray-300">
              Ovylon™, el nombre, el logo, la interfaz y los elementos del producto son propiedad de Ovylon o sus
              licenciantes. No adquieres derechos sobre nuestras marcas o contenido del servicio por usar la plataforma.
            </p>
            <p className="mt-3 text-sm text-gray-300">
              Si crees que algo infringe tus derechos, contáctanos por{" "}
              <Link to="/support" className="text-indigo-300 hover:text-indigo-200 transition">
                Soporte
              </Link>
              .
            </p>
          </section>

          {/* 8 */}
          <section className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <h2 className="text-lg font-semibold text-gray-100">8) Servicios de terceros</h2>
            <p className="mt-3 text-sm text-gray-300">
              Ovylon puede integrar proveedores externos (por ejemplo: infraestructura, pagos, analítica, email, modelos).
              Esos servicios pueden estar sujetos a términos propios. No somos responsables por fallos ajenos a Ovylon
              fuera de nuestro control razonable.
            </p>
          </section>

          {/* 9 */}
          <section className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <h2 className="text-lg font-semibold text-gray-100">9) Terminación y suspensión</h2>
            <ul className="mt-3 text-sm text-gray-300 space-y-2">
              <li>• Puedes dejar de usar Ovylon en cualquier momento.</li>
              <li>• Podemos suspender o terminar acceso si hay abuso, fraude, violaciones de estos términos o riesgo al servicio.</li>
              <li>• Algunas secciones sobreviven a la terminación (por ejemplo: limitaciones, propiedad intelectual, etc.).</li>
            </ul>
          </section>

          {/* 10 */}
          <section className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <h2 className="text-lg font-semibold text-gray-100">10) Exención de garantías y limitación de responsabilidad</h2>
            <p className="mt-3 text-sm text-gray-300">
              Ovylon se ofrece “tal cual” y “según disponibilidad”. En la medida permitida por la ley, no garantizamos que
              el servicio sea ininterrumpido o libre de errores, ni que el contenido generado cumpla un propósito
              específico sin revisión humana.
            </p>
            <p className="mt-3 text-sm text-gray-300">
              En la medida permitida por la ley aplicable, Ovylon no será responsable por daños indirectos, incidentales,
              especiales o consecuentes derivados del uso o imposibilidad de uso del servicio.
            </p>
          </section>

          {/* 11 */}
          <section className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <h2 className="text-lg font-semibold text-gray-100">11) Ley aplicable</h2>
            <p className="mt-3 text-sm text-gray-300">
              Estos términos se rigen por las leyes de los Estados Unidos y, cuando corresponda, por las leyes del estado
              donde Ovylon esté establecido/registrado.
            </p>
          </section>

          {/* 12 */}
          <section className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <h2 className="text-lg font-semibold text-gray-100">12) Contacto</h2>
            <p className="mt-3 text-sm text-gray-300">
              Para preguntas sobre estos términos, visita{" "}
              <Link to="/support" className="text-indigo-300 hover:text-indigo-200 transition">
                Soporte
              </Link>{" "}
              o escríbenos al correo publicado allí.
            </p>
          </section>

          {/* ✅ Volver al inicio (justo encima del footer, consistente) */}
          <div className="pt-2">
            <Link to="/" className="text-sm text-gray-300 hover:text-white transition">
              ← Volver al inicio
            </Link>
          </div>
        </div>
      </main>

      {/* ─────────── FOOTER ─────────── */}
      <footer className="border-t border-white/10 py-10 text-sm text-gray-500">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div>© {new Date().getFullYear()} Ovylon™ — All rights reserved.</div>

          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <Link to="/about" className="hover:text-gray-300 transition">
              Qué es Ovylon
            </Link>
            <Link to="/support" className="hover:text-gray-300 transition">
              Soporte
            </Link>
            <Link to="/privacy" className="hover:text-gray-300 transition">
              Privacidad
            </Link>
            <Link to="/terms" className="hover:text-gray-300 transition">
              Términos
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

